import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import email from "../assets/img/email.svg";
import axiosInstance from "../api/axiosInstance";
import { post } from "../api/services";
import { useLocation, useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../api/endpoints";
import { Modal } from "bootstrap";
import Success from "../assets/img/check1.svg";
import Spinner from "./Spinner";
import downloadBase64Pdf from "../utility/downloadBase64Pdf";
import { whitelistText } from "../utility/whitelistText";

const RmForm = ({ onPrevious, onCancel, steps, productList }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const previousPage = location?.state?.task || "";
  const [offerNo, setOfferNo] = useState(location?.state?.offerNo || "");
  const productListFromParams = location?.state?.productList || "";
  const {
    register,
    handleSubmit,
    setValue,
    getValues, // <-- Add this
    watch, // <-- Add this to watch form values
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [privacyError, setPrivacyError] = useState("");

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await post(API_ENDPOINTS.GET_USER_DETAILS, {
          offerno: offerNo,
        });

        if (response?.status === 200 && response?.data) {
          const userData = response?.data;

          // Map API response to form fields
          setValue("customerName", userData?.customer_name || "");
          setValue("contactNo", userData?.contact_number || "");
          setValue("email", userData?.customer_email || "");
          setValue("address", userData?.customer_address || "");
          setValue("rmName", userData?.rm_name || "");
          setValue("rmContactNo", userData?.rm_mobile || "");
          setValue("rmEmail", userData?.rm_email || "");
        }
      } catch (error) {
        showError("User Details", "Error fetching user details:");
      }
    };
    const getCustomerName = (data) => {
      if (data) {
        for (const section of data) {
          if (section?.question) {
            for (const question of section?.question) {
              if (question?.name === "customerName") {
                return question?.answer;
              }
            }
          }
        }
      }
      return null; // Return null if customerName is not found
    };
    if (offerNo !== "" || null || undefined) {
      fetchUserDetails();
    } else {
      setValue("customerName", getCustomerName(steps));
    }
  }, [offerNo]);

  const showError = (inputName, message) => {
    setError((prevError) => ({ ...prevError, [inputName]: message }));
  };

  const onBackToCustomerSearch = () => {
    navigate(-1);
  };
  const openModal = () => {
    const modalEl = document.getElementById("confirm");
    if (modalEl) {
      const modal = window.bootstrap
        ? window.bootstrap.Modal.getOrCreateInstance(modalEl)
        : Modal.getOrCreateInstance(modalEl);
      modal.show();
    }
  };

  const closeModal = () => {
    const modalEl = document.getElementById("confirm");
    if (modalEl) {
      const modal = window.bootstrap
        ? window.bootstrap.Modal.getOrCreateInstance(modalEl)
        : Modal.getOrCreateInstance(modalEl);
      modal.hide();
    }
  };

  const sendOffer = async (data) => {
    setLoading(true);
    const now = new Date();
    const offerDate = [
      String(now.getDate()).padStart(2, "0"),
      String(now.getMonth() + 1).padStart(2, "0"),
      now.getFullYear(),
    ].join("/");
    const temp = {
      productList: productListFromParams
        ? productListFromParams
        : productList
        ? productList
        : [],
      questionAnswers: JSON.stringify(steps) || [],
      customerDetails: data || "",
      offerDate: offerDate || "",
      offerNo: offerNo || "",
    };

    try {
      const response = await post(API_ENDPOINTS.GENERATE_OFFER, temp);
      if (response?.status === 200 && response?.data) {
        const { pdf, fileName, offerNo } = response?.data;
        setOfferNo(offerNo);
        if (pdf && fileName) {
          downloadBase64Pdf(pdf, fileName);
        }
        openModal();
      } else {
        alert("Error generating offer letter");
      }
    } catch (error) {
      showError("Offer Letter", "Error sending offer letter");
    } finally {
      setLoading(false);
    }
  };

  const handleOfferLetter = async (data) => {
    if (!privacyChecked) {
      setPrivacyError("You must accept the privacy policy");
      return;
    }
    setPrivacyError("");
    await sendOffer(data);
  };

  const handleResend = async () => {
    closeModal();
    // Wait for modal to close before resending
    setTimeout(async () => {
      await sendOffer(getValues());
    }, 300);
  };

  const handleClose = () => {
    closeModal();
    navigate("/customerscreen");
  };

  return (
    <form
      onSubmit={handleSubmit(handleOfferLetter)}
      className="multistep_sec"
      autoComplete="off"
    >
      {loading && (
        <div className="spinner-backdrop">
          <Spinner size={50} color="#98272A" />
        </div>
      )}
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="menu_link_section">
              <div className="content_box">
                <div className="form-card">
                  <div className="row align-items-center">
                    <div className="col-md-12">
                      <div className="summary_details_box">
                        <div className="top_box">
                          <div className="heading_box">
                            <h4>
                              Great!
                              <br />
                              Everything is ready.
                            </h4>
                            {previousPage !== "customerSearch1" && (
                              <p>
                                Would you like to get the offer letter on your
                                email or would
                                <br />
                                like to{" "}
                                <span
                                  onClick={onPrevious}
                                  style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  Go Back
                                </span>{" "}
                                and change some details
                              </p>
                            )}
                          </div>
                          <div className="icon">
                            <img src={email} alt="Email Icon" />
                          </div>
                        </div>

                        <div className="customer_details">
                          <div className="row">
                            <div className="col-md-12 mb-4">
                              <div className="customer_heading mb-2">
                                <h3>Customer Details</h3>
                              </div>
                            </div>

                            {/* Customer Name */}
                            <div className="col-md-6 mb-4">
                              <div className="form-group">
                                <label htmlFor="customerName">
                                  Customer Name
                                </label>
                                <input
                                  type="text"
                                  id="customerName"
                                  autoComplete="off"
                                  disabled={true}
                                  className={`form-control ${
                                    errors.customerName ? "is-invalid" : ""
                                  }`}
                                  {...register("customerName", {
                                    required: "Customer Name is required",
                                    validate: (value) => {
                                      if (value.length > 100) {
                                        return "Customer Name must be less than or equal to 100 characters";
                                      }
                                      if (!whitelistText(value)) {
                                        return "Customer Name contains invalid characters";
                                      }
                                      return true;
                                    },
                                  })}
                                />
                                {errors.customerName && (
                                  <div className="invalid-feedback">
                                    {errors.customerName.message}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Contact Number */}
                            <div className="col-md-6 mb-4">
                              <div className="form-group">
                                <label htmlFor="contactNo">Contact No.</label>
                                <input
                                  type="text"
                                  id="contactNo"
                                  autoComplete="off"
                                  className={`form-control ${
                                    errors.contactNo ? "is-invalid" : ""
                                  }`}
                                  {...register("contactNo", {
                                    required: "Contact Number is required",
                                    pattern: {
                                      value: /^[0-9]{10}$/,
                                      message:
                                        "Contact Number must be 10 digits",
                                    },
                                  })}
                                />
                                {errors.contactNo && (
                                  <div className="invalid-feedback">
                                    {errors.contactNo.message}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Email Address */}
                            <div className="col-md-12 mb-4">
                              <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                  type="email"
                                  id="email"
                                  autoComplete="off"
                                  maxLength={254}
                                  className={`form-control ${
                                    errors.email ? "is-invalid" : ""
                                  }`}
                                  {...register("email", {
                                    required: "Email is required",
                                    // Remove the regex pattern, or keep it simple
                                    // pattern: {
                                    //   value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    //   message: "Invalid email address",
                                    // },
                                  })}
                                />
                                {errors.email && (
                                  <div className="invalid-feedback">
                                    {errors.email.message}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Customer Address */}
                            <div className="col-md-12 mb-4">
                              <div className="form-group">
                                <label htmlFor="address">
                                  Customer Address
                                </label>
                                <textarea
                                  id="address"
                                  autoComplete="off"
                                  className={`form-control ${
                                    errors.address ? "is-invalid" : ""
                                  }`}
                                  {...register("address", {
                                    required: "Address is required",
                                    validate: (value) => {
                                      if (value.length > 250) {
                                        return "Address must be less than or equal to 250 characters";
                                      }
                                      if (!whitelistText(value)) {
                                        return "Address contains invalid characters";
                                      }
                                      return true;
                                    },
                                  })}
                                />
                                {errors.address && (
                                  <div className="invalid-feedback">
                                    {errors.address.message}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12 mb-4">
                              <div className="customer_heading mt-2 mb-2">
                                <h3>RM Details</h3>
                              </div>
                            </div>

                            {/* RM Name */}
                            <div className="col-md-6 mb-4">
                              <div className="form-group">
                                <label htmlFor="rmName">RM Name</label>
                                <input
                                  type="text"
                                  id="rmName"
                                  autoComplete="off"
                                  className={`form-control ${
                                    errors.rmName ? "is-invalid" : ""
                                  }`}
                                  {...register("rmName", {
                                    required: "RM Name is required",
                                    validate: (value) => {
                                      if (value.length > 100) {
                                        return "RM Name must be less than or equal to 100 characters";
                                      }
                                      if (!whitelistText(value)) {
                                        return "RM Name contains invalid characters";
                                      }
                                      return true;
                                    },
                                  })}
                                />
                                {errors.rmName && (
                                  <div className="invalid-feedback">
                                    {errors.rmName.message}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* RM Contact Number */}
                            <div className="col-md-6 mb-4">
                              <div className="form-group">
                                <label htmlFor="rmContactNo">Contact No.</label>
                                <input
                                  type="text"
                                  id="rmContactNo"
                                  autoComplete="off"
                                  className={`form-control ${
                                    errors.rmContactNo ? "is-invalid" : ""
                                  }`}
                                  {...register("rmContactNo", {
                                    required: "RM Contact Number is required",
                                    pattern: {
                                      value: /^[0-9]{10}$/,
                                      message:
                                        "Contact Number must be 10 digits",
                                    },
                                  })}
                                />
                                {errors.rmContactNo && (
                                  <div className="invalid-feedback">
                                    {errors.rmContactNo.message}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* RM Email Address */}
                            <div className="col-md-12 mb-4">
                              <div className="form-group">
                                <label htmlFor="rmEmail">Email Address</label>
                                <input
                                  type="email"
                                  id="rmEmail"
                                  autoComplete="off"
                                  maxLength={254}
                                  className={`form-control ${
                                    errors.rmEmail ? "is-invalid" : ""
                                  }`}
                                  {...register("rmEmail", {
                                    required: "RM Email is required",
                                    // pattern: {
                                    //   value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
                                    //   message: "Invalid email address",
                                    // },
                                    validate: (value) =>
                                      value.endsWith("@indusind.com") ||
                                      "Email must end with @indusind.com",
                                  })}
                                />
                                {errors.rmEmail && (
                                  <div className="invalid-feedback">
                                    {errors.rmEmail.message}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-12 mb-2">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  minHeight: 40,
                                }}
                              >
                                <input
                                  id="privacyPolicy"
                                  name="privacyPolicy"
                                  type="checkbox"
                                  autoComplete="off"
                                  checked={privacyChecked}
                                  onChange={(e) =>
                                    setPrivacyChecked(e.target.checked)
                                  }
                                  style={{
                                    position: "relative",
                                    border: "1px solid #C4C4C4",
                                    borderRadius: "8px",
                                    background: "none",
                                    cursor: "pointer",
                                    lineHeight: 0,
                                    margin: "0 12px 0 0",
                                    outline: 0,
                                    padding: 0,
                                    verticalAlign: "text-top",
                                    height: "30px",
                                    width: "30px",
                                    WebkitAppearance: "none",
                                    appearance: "none",
                                    opacity: 1,
                                    backgroundColor: privacyChecked
                                      ? "#98272A"
                                      : "#fff",
                                    borderColor: privacyChecked
                                      ? "#98272A"
                                      : "#C4C4C4",
                                    transition: "background 0.2s, border 0.2s",
                                    display: "inline-block",
                                  }}
                                />
                                {/* Checkmark overlay */}
                                {privacyChecked && (
                                  <span
                                    style={{
                                      position: "absolute",
                                      pointerEvents: "none",
                                      color: "#fff",
                                      fontSize: "18px",
                                      left: 23,
                                      top: 5,
                                      userSelect: "none",
                                    }}
                                  >
                                    ✓
                                  </span>
                                )}
                                <label
                                  htmlFor="privacyPolicy"
                                  style={{
                                    margin: 0,
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                    lineHeight: 1.2,
                                  }}
                                >
                                  I accept &amp; agree to the Bank's{" "}
                                  <a
                                    href="https://www.indusind.com/in/en/personal/privacy-policy.html"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#98272A",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    privacy policy
                                  </a>
                                </label>
                              </div>
                              {privacyError && (
                                <div
                                  className="text-danger"
                                  style={{ marginTop: "5px" }}
                                >
                                  {privacyError}
                                </div>
                              )}
                            </div>
                            <div className="col-md-12 mt-3">
                              <div className="confirm_btn">
                                <button
                                  type="button"
                                  className="no confirm"
                                  onClick={() => {
                                    previousPage === ""
                                      ? onCancel()
                                      : onBackToCustomerSearch();
                                  }}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="submit"
                                  className="confirm"
                                  disabled={loading}
                                >
                                  Confirm
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="modal fade" id="confirm" tabIndex="-1">
                          <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-body">
                                <div className="confirm">
                                  <div className="con_content">
                                    <img src={Success} alt="Success Icon" />
                                    <h3>Offer letter sent Successfully!!</h3>
                                    <p>
                                      The offer letter has been sent to your
                                      official email id
                                      <br />
                                      {getValues("rmEmail")}
                                    </p>
                                    <div className="resend_btn">
                                      <button
                                        type="button"
                                        className="offer_close"
                                        onClick={handleClose}
                                      >
                                        Close
                                      </button>
                                      <button
                                        type="button"
                                        className="latter"
                                        onClick={handleResend}
                                      >
                                        Resend Offer Letter
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default RmForm;
